export const Navis = {
  LOGIN: 'login',
  REGISTER: 'register',
  API: 'apis',
  DOC: 'docs',
  APP: 'app',
  CREDENTIALS: 'credentials',
  PERMISSIONS: 'permissions',
  WEBHOOKS: 'webhooks',
  WEBHOOK: 'webhook',
  OVERVIEW: 'overview',
  OAUTH: 'oauth',
};

export const navlist = [
  {
    activeInPathname: '/docs/guides',
    id: 1,
    name: 'guides',
    sectionId: 'menu-section-guides',
    path: '/docs/guides/',
    icon: 'GuidesIcon',
  },
  {
    activeInPathname: '/docs/apis',
    id: 2,
    name: 'apis',
    sectionId: 'menu-section-apis',
    path: '/docs/apis/',
    icon: 'ApisIcon',
  },
  {
    activeInPathname: '/docs/sdks',
    id: 3,
    name: 'sdks',
    sectionId: 'menu-section-sdks',
    path: '/docs/sdks/',
    icon: 'SdksIcon',
  },
];
